<div class="info-message">
    <mat-icon class="info_outlined">info_outlined</mat-icon>
    Please enter the LinkedIn profile URL of your connection and click on the Check button. 
    If the person already exists in our database, the available details will be automatically filled in, 
    If not, you will need to enter the details of your connection.
</div>
